import React from 'react';
import { ArrowRight } from 'lucide-react';
import { mockData } from '../data/mock';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="accueil" className="hero-section">
      <div className="hero-background">
        {/* Photo Bouhdel auto-hébergée : plus aucune requête vers un tiers,
            et c'est une vraie réalisation plutôt qu'une image de stock. */}
        <img
          src="/assets/photos/drone/DJI_0046.webp"
          alt=""
          className="hero-image"
          width={1600}
          height={900}
          fetchPriority="high"
        />
        <div className="hero-overlay"></div>
      </div>
      
      <div className="hero-content">
        <h1 
          className="hero-title"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          {mockData.company.tagline}
        </h1>
        <p 
          className="hero-subtitle"
          data-aos="fade-up"
          data-aos-delay="400"
        >
          {mockData.company.description}
        </p>
        <div 
          className="hero-cta-group"
          data-aos="fade-up"
          data-aos-delay="600"
        >
          <button onClick={scrollToContact} className="btn-primary btn-hero">
            Demander un devis
            <ArrowRight size={20} style={{ marginLeft: '8px' }} />
          </button>
          <button onClick={scrollToContact} className="btn-secondary btn-hero">
            Nous contacter
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
